import { ProjectStatusType } from '@/types';

export interface StatusOption {
  value: ProjectStatusType;
  label: string;
}

export const PROJECT_STATUSES: StatusOption[] = [
  { value: 'planning', label: 'Planning' },
  { value: 'in progress', label: 'In Progress' },
  { value: 'on hold', label: 'On Hold' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'completed', label: 'Completed' },
];

/**
 * Normalizes a raw status string to one of the canonical PROJECT_STATUSES values.
 * Mirrors the backend NormalizeCostCentreStatus / NormalizeProjectStatus logic so
 * that settings values like 'active' or 'reopened' correctly map to the UI statuses.
 */
export const normalizeStatusValue = (status: string | null | undefined): ProjectStatusType => {
  const s = (status ?? '').trim().toLowerCase();
  switch (s) {
    case 'planning':
    case 'planned':
    case 'estimate':
    case 'opportunity':
      return 'planning';
    case 'in progress':
    case 'in-progress':
    case 'inprogress':
    case 'active':
    case 'reopened':
      return 'in progress';
    case 'on hold':
    case 'on-hold':
    case 'onhold':
    case 'suspended':
      return 'on hold';
    case 'cancelled':
    case 'canceled':
    case 'archived':
      return 'cancelled';
    case 'completed':
    case 'complete':
    case 'finished':
    case 'closed':
      return 'completed';
    default:
      return 'planning';
  }
};
